import { render } from "./Loader.vue?vue&type=template&id=24841763"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=24841763&lang=css"

import exportComponent from "/home/runner/work/lifepass-passes-app/lifepass-passes-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__